import axios from "axios";

const API_BASE ="https://api.monappliclub.com";

const baseUrl = `${API_BASE}/api/updates`;

export const getAllUpdates = async () => {
  const { data } = await axios.get(`${baseUrl}/AllUpdates`);
  return data;
};